import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";

const B = `${process.env.REACT_APP_BACKEND_URL}/api/public/galeri`;

export default function Galeri() {
  const { token } = useParams();
  const [d, setD] = useState(null);
  const [bad, setBad] = useState(false);
  useEffect(() => { axios.get(`${B}/${token}`).then(({ data }) => setD(data)).catch(() => setBad(true)); }, [token]);
  if (bad) return <div className="p-10 text-center text-slate-500" data-testid="galeri-404">Galeri tidak ditemukan.</div>;
  if (!d) return <div className="p-10 text-center text-slate-400">Memuat…</div>;
  return (
    <div className="min-h-screen bg-slate-50 p-5 sm:p-10" data-testid="galeri-page">
      <div className="max-w-4xl mx-auto">
        <img src="/logo-fomu.png" alt="FOMU 3D PRINT" className="h-8 mb-6" onError={(e) => { e.currentTarget.style.display = "none"; }} />
        <h1 className="font-head text-3xl sm:text-4xl font-bold">{d.product}</h1>
        <p className="text-sm text-slate-500 mt-1">{d.wo_code} · hasil unit sebelum dipacking</p>
        <div className="grid grid-cols-2 gap-3 mt-6">
          {d.photos.map((_, i) => <img key={i} src={`${B}/${token}/file/${i}?kind=photos`} alt="" className="w-full aspect-square object-cover rounded-2xl" data-testid={`galeri-photo-${i}`} />)}
        </div>
        <div className="grid sm:grid-cols-2 gap-3 mt-3">
          {d.videos.map((_, i) => <video key={i} src={`${B}/${token}/file/${i}?kind=videos`} controls playsInline className="w-full rounded-2xl bg-black" data-testid={`galeri-video-${i}`} />)}
        </div>
        <p className="text-sm text-slate-600 mt-6">Bila sudah sesuai, balas OK di WhatsApp. Ada yang kurang pas? Sampaikan di WhatsApp, tim kami akan memperbaikinya.</p>
      </div>
    </div>
  );
}
